import { createSlice } from "@reduxjs/toolkit";
import {
  AllPaymentsThunk,
  GetSingleInvoiceThunk,
  AddInvoiceThunk,
  UpdateInvoiceThunk,
  DeleteInvoiceThunk
} from "./thunk";

const initialState = {
  payments: [],
  singlePayment: null,
  loading: false,
  error: null,
  successMessage: null,
};

const paymentsSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    clearPaymentState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // -------------------- ALL PAYMENTS --------------------
      .addCase(AllPaymentsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllPaymentsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = action.payload?.data || [];
      })
      .addCase(AllPaymentsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- SINGLE PAYMENT --------------------
      .addCase(GetSingleInvoiceThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleInvoiceThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singlePayment = action.payload?.data || null;
      })
      .addCase(GetSingleInvoiceThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- ADD PAYMENT --------------------
      .addCase(AddInvoiceThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(AddInvoiceThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Invoice added successfully!";
      })
      .addCase(AddInvoiceThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- UPDATE PAYMENT --------------------
      .addCase(UpdateInvoiceThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(UpdateInvoiceThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Invoice updated successfully!";
      })
      .addCase(UpdateInvoiceThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- DELETE PAYMENT --------------------
      .addCase(DeleteInvoiceThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(DeleteInvoiceThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = state.payments.filter(p => p.uuid !== action.payload.uuid);
        state.successMessage = action.payload.message || "Invoice deleted successfully!";
      })
      .addCase(DeleteInvoiceThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPaymentState } = paymentsSlice.actions;
export default paymentsSlice.reducer;
